import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { StyledRefreshBtn } from './style';
import CTA from '../CTA';
import Text from '../Text';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';
import {
  CACHE_INVALIDATE,
  LAST_CACHE_INVALIDATE_GET,
} from '../../../app/redux/actions/supervisorStats';
import { timestampToDate } from '../../../utils/common';

const RefreshBtn = ({
  cacheTag,
  last_update,
  getLastCacheInvalidate,
  cacheInvalidate,
  callback,
}) => {
  const [allowUpdate, setAllowUpdate] = useState(false);
  useEffect(() => {
    if (cacheTag) getLastCacheInvalidate(cacheTag);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cacheTag]);

  useEffect(() => {
    if (allowUpdate && last_update) {
      callback();
      setAllowUpdate(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [last_update]);

  return (
    <StyledRefreshBtn>
      <CTA
        type="secondary"
        btnText="Aggiorna"
        icon="refresh-cw-05"
        onClick={() => {
          cacheInvalidate(cacheTag);
          setAllowUpdate(true);
        }}
        compact
        iconSize={20}
        disabled={!cacheTag}
      />
      <Text type="b5">
        Data ultimo aggiornamento:
        <br />
        {timestampToDate(last_update[cacheTag], 'DD/MM/YYYY - HH:mm')}
      </Text>
    </StyledRefreshBtn>
  );
};

RefreshBtn.propTypes = {
  cacheTag: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
  // HOC: state
  last_update: PropTypes.object,
  // HOC: dispatch
  getLastCacheInvalidate: PropTypes.func,
  cacheInvalidate: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { last_update } = state.supervisorStats.charts;
      return { last_update };
    },
    (dispatch) => ({
      getLastCacheInvalidate: (cacheTag) =>
        dispatch({ type: LAST_CACHE_INVALIDATE_GET._REQUEST, cacheTag }),
      cacheInvalidate: (cacheTag) =>
        dispatch({
          type: CACHE_INVALIDATE._REQUEST,
          payload: { cache_tag: cacheTag },
        }),
    })
  ),
  withMediaQueries
)(RefreshBtn);
